import React, { useEffect, useState } from 'react';

export const BedsteadManagement = (props) =>{
    return(
    <>
    
    </>
    )
}